import axios from 'axios';

const agm = axios.create({
    baseURL: process.env.REACT_APP_AGM_ENDPPOINT
})

export default agm;